import React from 'react'
import { updateFavouriteListApi } from '../../../../services/groups';
import { toastMessage } from '../../../../utils/toastMessage';

export const updateFavoriteListHandler = async (favGroupId, setData, status, compName, listing = () => { }) => {
    try {
        const { data } = await updateFavouriteListApi({
            _group: favGroupId,
        });
        const { success, message } = data;
        if (success) {
            // toastMessage(message, "success", "updateGroupSetting");
            if (compName === 'favorite') {
                listing()
            }
            setData((prev) => {
                const temp = [...prev]
                // const foundItem = temp.find(item => item._id === favGroupId);
                const foundItem = temp.find(item => item._id === favGroupId || item?._group?._id === favGroupId);
                if (foundItem) {
                    if (status === "ACTIVE") {
                        foundItem.favoriteGroup = {
                            status: "ACTIVE",
                        };
                    } else if (status === "INACTIVE") {
                        delete foundItem.favoriteGroup;
                    }
                }
                return temp;
            })
        } else {
            toastMessage(message, "error", "updateGroupSetting");
        }
    } catch (error) {
        console.error("Error updating settings:", error?.message);
        toastMessage("Failed to update settings. Please try again.", "errorLike");
    }
};

